var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("pui-lightbox", {
        ref: "ConfirmationModalRef",
        staticClass: "modal",
        attrs: {
          "fit-content": true,
          fullscreen: false,
          "show-lightbox-close-icon": false,
          "default-header-label": _vm.headerLabel,
          "default-footer-confirm-label": _vm.confirmLabel,
          "default-footer-cancel-label": _vm.cancelLabel,
          "on-confirm-callback": _vm.onConfirm,
          "on-cancel-callback": _vm.onCancel,
        },
        on: { "puilightbox:close": _vm.closeModal },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c("div", { staticStyle: { "margin-top": "2.4rem" } }, [
                  _vm._v(" " + _vm._s(_vm.messageText) + " "),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }